import MentionCollection from './bill_search_mention_collection';
import ResourcesModel from './bill_search_resources_model';
export default Backbone.Model.extend({
  parse: function (response) {
    const data = response;
    if (response.mentions) {
      data.mentions = new MentionCollection(response.mentions);
    }
    if (response.resources) {
      data.resources = new ResourcesModel(response.resources);
    }
    if (response.data) {
      data.version_id = response.data.id;
      data.bill_id = response.data.bill_id;
    }
    return data;
  }
});